require('./init-web-common');
var $ = require('jquery');

var mobileBar = require('./mobilebar/web');
$(function () {
    mobileBar.init();
});



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/init-web.js
 ** module id = 0
 ** module chunks = 12
 **/